<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                
                        
                        <div class="modal-body">
                          <div class="row">
                            <div class="col-7">
                              <div class="maheading_2">
                                <h5 class="modal-title">Add Subscription</h5>
                              </div>  
                            </div>
                            <div class="col-5 text-right">
                              &nbsp;
                            </div>
                          </div>


            <div class="" v-if="unitType == 'Seat'">
              <b-card no-body>
                <b-tabs card>
                  <b-tab title="Monthly" @click="selectType('monthly')" :active="type == 'monthly'">
                    <b-card-text>


                        <div class="monthly">
                        <div class="border rounded shadow px-4 py-3 mb-4" >



                        <div class="pb-4 subscription_box" v-for="(list, index) in subscriptions_monthly"  :key="'m' + index">
                          <div class="row">
                              <div class="col-7" style="margin-top: -10px !important;">
                                <div class="custom-control custom-radio custom-control-inline" style="margin-right: 0px !important;">
                                <input
                                  type="radio"
                                  v-bind:id="'is_primary_' + index" 
                                  :ref="'is_primary_' + index"
                                  v-bind:name="'is_primary[' + index + ']'"
                                  v-model="list.isSelected"
                                  :checked="list.checked"
                                  @click="clickPrimary(index, 'monthly')"
                                  :value="1" class="custom-control-input" style="margin-top: -2px !important; height: 10px;">
                                <label 
                                  class="custom-control-label" 
                                  :for="'is_primary_' + index" style="margin-top: 9px !important;"></label>
                              </div>

                                {{ list.packageName }}
                              </div>
                              <div class="col-5 text-right pr-4">
                                &#36;{{ list.packagePrice }}/billed monthly
                              </div>
                          </div>
                          <div class="row" >
                            <div class="col-7 seat_qty" >
                              &nbsp;
                            </div>
                            <div class="col-5 text-right annual pr-4" >
                              Annual subscription
                            </div>
                          </div>
                          <div class="row" >
                            <div class="col-8 seat_qty" style="padding-left: 43px !important;">
                              {{ list.packageQty }}
                            </div>
                            <div class="col-4 text-right seat_qty pr-4 bold" v-if="list.packagediscount > 0">
                              ({{ list.packagediscount }}% Savings)
                            </div>
                          </div>
                          <div class="clear"></div>
                        </div>

                        </div>
                        </div>

                                </b-card-text>
                              </b-tab>
                              <b-tab title="Annual" @click="selectType('yearly')" :active="type == 'yearly'">
                                <b-card-text>

                        <div class="yearly">
                        <div class="border rounded shadow px-4 py-3 mb-4" >
                        <div class="pb-4 subscription_box" v-for="(list, index) in subscriptions_yearly" :key="'y' + index">
                          <div class="row">
                              <div class="col-7" style="margin-top: -10px !important;">
                                <div class="custom-control custom-radio custom-control-inline" style="margin-right: 0px !important;">
                                  <input
                                    type="radio"
                                    v-bind:id="'is_monthly_primary_' + index" 
                                    :ref="'is_monthly_primary_' + index"
                                    v-bind:name="'is_monthly_primary_[' + index + ']'"
                                    v-model="list.isSelected"
                                    :checked="list.checked"
                                    @click="clickPrimary(index, 'yearly')"
                                    :value="1" class="custom-control-input" style="margin-top: -2px !important; height: 10px;">
                                  <label 
                                    class="custom-control-label" 
                                    :for="'is_monthly_primary_' + index" style="margin-top: 9px !important;"></label>
                                </div>
                                {{ list.packageName }}
                              </div>
                              <div class="col-5 text-right pr-4">
                                &#36;{{ list.packagePrice }}/billed annually
                              </div>
                          </div>
                          <div class="row pt-2" >
                            <div class="col-8 seat_qty" style="padding-left: 43px !important;">
                              {{ list.packageQty }}
                            </div>
                            <div class="col-4 text-right seat_qty pr-4 bold" v-if="list.packagediscount > 0">
                              ({{ list.packagediscount }}% Savings)
                            </div>
                          </div>
                          <div class="clear"></div>
                        </div>

                        </div>
                        </div>

                                </b-card-text>
                              </b-tab>
                            </b-tabs>
                          </b-card>
                        </div>




            <div class="border rounded shadow px-4 py-3 mb-4"  v-if="unitType == 'Seat' && unlimited == false">
            
              <div class="row">
                  <div class="col-8">
                    {{ packageName }}
                    
                  </div>
                  <div class="col-4 text-right pr-4">
                    &#36;{{ packagePrice }}
                  </div>
              </div>


              <div class="row pt-2" v-if="unlimited == false">
                  <div class="col-8">
                    Additional Mentees: <b-form-select class="col-2 ma-input-field" v-model="additionalSeatQty" name="unit" :options="seat_qty_options" placeholder="Qty" @change="getAdditionalPriceforSubscription">           
                    </b-form-select>
                  </div>
                  <div class="col-4 text-right pr-4" v-if="totaladditionalSeatPrice > 0">
                    &#36;{{ totaladditionalSeatPrice }}
                  </div>
              </div>
              <div class="row mt-2">
                  <div class="col-8" style="font-size: 12px !important;">
                    {{ packageQtyDisplay }}
                  </div>
                  <div class="col-4 text-right pr-3">
                    <div v-if="type == 'yearly'" class="mb-1 pr-2 text-right">Total: ${{ total_amt }}/annually</div>
                    <div  v-if="type == 'monthly'" class="pr-2 mb-0  text-right">Total: ${{ total_amt }}/monthly</div>
                    <div  v-if="type == 'monthly'" class="annual mb-1 pr-2 text-right"><i>Annual subscription</i></div>
                  </div>
              </div>
              <div class="clear"></div>

            </div>












                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow"  v-if="unitType == 'License'">
                           
                             <div class="row">
                                <div class="col-12">
                                    <div class="row">
                                      <div class="col-6">
                                        <span><label class="form-label">Unit Type</label></span>
                                        
                                      </div>
                                      <div class="col-2">
                                        <label class="form-label text-center" style="width: 100%;">Quantity</label>
                                      </div>
                                      <div class="col-4">
                                        <label class="form-label text-center" style="width: 100%;">Price</label>
                                      </div>
                                    </div>
                                    <div class="row row_data_border" v-for="(pitem, sindex) in subscriptions" :key="sindex">
                                      <div class="col-6">
                                        <label :for="'subscription_plan_' + sindex">{{ pitem.name }}(s)</label>
                                      </div>
                                      <div class="col-3" >
                                        <b-form-select class="col-12 ma-input-field" v-model="unit" name="unit" :options="qty_options" placeholder="Qty" v-validate="'required'"   @change="getPriceforSubscription">           
                                        </b-form-select>
                                      </div>

                                    <div class="col-3">
                                        <label for=""  style="width: 100%; text-align: center;"><span class="dollarsign" >$</span>&nbsp;{{ pitem.price }}/{{ pitem.duration }}</label>
                                    </div>

                                    <div v-if="verrors.firstByRule('unit', 'required')" class="margin-bottom-5 validate-warning-msg" style="padding-left: 15px;">Quantity is required</div>
                                    </div>                                        

                                    <div class="row">
                                      <div class="col-9 text-right pr-0" style="padding-top: 8px;">
                                        &nbsp;
                                      </div>
                                      <div class="col-3 col-sm-3 pl-0" style="text-align: right;  padding-right: 45px;">
                                        <button type="button" class="btn btn-sm btn-blue totalBtn text-center">
                                          Total: <span class="total_price">${{ subscriptionTotal }}</span>
                                        </button>
                                      </div>
                                    </div>

                                </div>
                            </div>

                          </div>



                        <div class="row mt-4" >
                          <div class="col-12">
                            <label class="form-label">Credit/Debit Card Information</label>
                              <div class="row mt-3">
                                <div class="col-sm-12 col-md-12">
                                  <div class="row">
                                    <div class="col-sm-12 col-md-12">
                                      <input 
                                          type="text" 
                                          class="col-12 col-sm-12 input-height-35 form-control" 
                                          name="card_no" 
                                          v-model="cardNumber" 
                                          v-validate="'required|numeric'"
                                          placeholder="Credit Number">
                                          <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                                          <div v-if="verrors.firstByRule('card_no', 'numeric')" class="margin-bottom-5 validate-warning-msg">Card Number must contain numeric characters only</div>
                                        </div>
                                      </div>
                                      <div class="row mt-2">
                                        <div class="col-sm-12 col-md-12">
                                          <input 
                                            type="text" 
                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                            name="name_on_card" 
                                            v-model="nameOnCard" 
                                            v-validate=" isCCRequired ? 'required' : '' "
                                            placeholder="Name on Card">
                                            <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                                        </div>
                                      </div>
                                      <div class="row mt-2">
                                        <div class="col-6 col-sm-6">
                                          <select 
                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                            name="exp_month" 
                                            v-model="expMonth" 
                                            v-validate="'required'">
                                            <option value="">Month</option>
                                            <option value="01">01</option>
                                            <option value="02">02</option>
                                            <option value="03">03</option>
                                            <option value="04">04</option>
                                            <option value="05">05</option>
                                            <option value="06">06</option>
                                            <option value="07">07</option>
                                            <option value="08">08</option>
                                            <option value="09">09</option>
                                            <option value="10">10</option>
                                            <option value="11">11</option>
                                            <option value="12">12</option>
                                          </select>
                                          <div v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg">Month is required</div>
                                        </div>
                                        <div class="col-6 col-sm-6">
                                          <b-form-select
                                              class="col-12 col-sm-12 input-height-35 form-control"
                                              name="exp_year" 
                                              v-model="expYear" 
                                              v-validate="'required'"
                                              :options="year_options">
                                          </b-form-select>
                                          <div v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg">Year is required</div>   
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>




                          <div class="row pt-4">
                              <div class="col-12">
                                <label class="form-label">Billing Information</label>
                                <div class="row mt-3">
                                  <div class="col-12 col-sm-12">      
                                      <input
                                        type="text"
                                        id="bname"
                                        class="col-12 col-sm-12 input-height-35 form-control"
                                        ref="bname"
                                        name="bname"
                                        v-model="billingName"
                                        v-validate="{ rules: { required: true, regex: billingNameRegex() } }"
                                        placeholder="Billing Name"
                                        maxlength="250"
                                        autocomplete="off">
                                      <div v-if="verrors.firstByRule('bname', 'required')" class="margin-bottom-5 validate-warning-msg">Billing name is required</div>
                                      <div v-if="verrors.firstByRule('bname', 'regex')" class="margin-bottom-5 validate-warning-msg">Billing name should only contain - and _</div>
                                    </div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-12 col-sm-12">
                                      <b-form-select
                                      class="col-12 col-sm-12 input-height-35 form-control"
                                      id="country_id" v-model="billingCountry" v-validate="'required'" name="billing_country"
                                      :options="country_options"
                                      v-on:change="getStateLists(billingCountry)">
                                      </b-form-select>
                                      <div v-if="verrors.firstByRule('billing_country', 'required')" class="margin-bottom-5 validate-warning-msg">Country is required</div>
                                    </div>
                                    <div class="col-12 col-sm-12 mt-2">
                                      <input 
                                          type="text" 
                                          class="col-12 col-sm-12 input-height-35 form-control" 
                                          name="billing_address_1" 
                                          placeholder="Billing Address 1" 
                                          v-model="billingAddress" 
                                          v-validate="'required'"
                                          maxlength="250">
                                      <div v-if="verrors.firstByRule('billing_address_1', 'required')" class="margin-bottom-5 validate-warning-msg">Billing Address 1 is required</div>
                                    </div>                 
                                    <div class="col-12 col-sm-12 mt-2">
                                      <input 
                                          type="text" 
                                          class="col-12 col-sm-12 input-height-35 form-control" 
                                          name="billing_address_2" 
                                          placeholder="Billing Address 2" 
                                          v-model="billingAddress2"
                                          maxlength="250" 
                                          >
                                    </div>                                                       
                                    <div class="col-12 col-sm-12 mt-2">
                                      <input 
                                      type="text" 
                                      name="phone number" 
                                      id="phone_number"
                                      ref="phone_number"
                                      v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                                      v-model="billingPhone"
                                      @keyup="billingPhoneValid"
                                      @blur="billingPhoneValid"
                                      class="col-12 col-sm-12 input-height-35 form-control" 
                                      placeholder="Phone Number"
                                      >
                                      <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>
                                    </div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-4 col-sm-4">
                                        <input 
                                            type="text" 
                                            class="col-12 col-sm-12 input-height-35 form-control" 
                                            name="billing_city" 
                                            placeholder="City" 
                                            v-model="billingCity" 
                                            v-validate="'required'"
                                            maxlength="150">
                                        <div v-if="verrors.firstByRule('billing_city', 'required')" class="margin-bottom-5 validate-warning-msg">City is required</div>
                                    </div>
                                    <div class="col-4 col-sm-4">
                                      <b-form-select
                                      class="col-12 col-sm-12 input-height-35 form-control"
                                      name="billing_state" v-model="billingState" v-validate="'required'"
                                      :options="state_options">
                                      </b-form-select>    
                                      <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">State is required</div>
                                    </div>
                                    <div class="col-4 col-sm-4">
                                      <input 
                                      type="text" 
                                      name="zip code" 
                                      id="org_zip"
                                      ref="org_zip"
                                      v-validate="{ rules: { regex: getPostalCodeRegex(), required: true } }"
                                      v-model="billingZip"
                                      maxlength="10"
                                      class="col-12 col-sm-12 input-height-35 form-control" 
                                      placeholder="Zip">
                                      <div v-show="verrors.has('zip code')" class="validate-warning-msg">{{ verrors.first('zip code') }}</div>
                                    </div>
                                  </div>
                              </div>
                          </div>

































                                <div class="text-center m-4">
                                    <button :disabled="process_payment_disable" type="button" class="btn btn-sm ma-blue-btn text-center" @click="onSubmit">
                                        Process Payment
                                    </button>
                                </div>
                                <div style="height: 20px;"></div>
                            
                        </div>
                        <div class="modal-footer"></div>
                    </div>
                </div>
            </div>
        </transition>

        <NewPaymentMethod
          :isModalVisible="isNewPaymentMethodModalVisible"
          ref="NewPaymentMethodModal"
          @close="isNewPaymentMethodModalVisible = false">
        </NewPaymentMethod>

        <PaymentLists
          :isModalVisible="isPaymentListsModalVisible"
          ref="PaymentListsModal"
          @close="isPaymentListsModalVisible = false">
        </PaymentLists>

        <AddLicenseSuccessModal 
            :isAddLicenseSuccessModalVisible="isAddLicenseSuccessModalVisible"
            :paymentMethod="paymentMethod"
            :invoice_filename="invoice_filename"            
            :unitType="unitType"
            landingPage="adminconsole"
            ref="add_license_success"
            @close="close"
        />

        <AddLicenseFailedModal
            :isAddLicenseFailedModalVisible="isAddLicenseFailedModalVisible"
            :unitType="unitType"
            landingPage="managelicense"
            @close="close"
        />

        <CreateInvoiceConfirmModal
            :isCreateInvoiceModalVisible="isCreateInvoiceModalVisible"
            landingPage="managelicense"            
            @close="close"
        />
        
    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import { BPopover } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)

import AddLicenseSuccessModal from './add_license_success_modal.vue';
import AddLicenseFailedModal from './add_license_failed_modal.vue';
import CreateInvoiceConfirmModal from './create_invoice_confirm_modal.vue';

import NewPaymentMethod from './new_payment_method.vue';
import PaymentLists from './payment_method_lists.vue';


Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible', 'totalLicense'],
    data() {
        return {
            loading: false,
            subscriptions: [],
            subscriptionId: '',
            subscription_plan: '',
            billingName: '',
            billingAddress: '',
            billingAddress2: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingZip: '',
            billingPhone: '',
            nameOnCard: '',
            cardNumber: '',
            expMonth: '',
            expYear: '',
            cvvValue: '',
            year_options: [],
            subscriptionTotal: 0,
            isAccessPlan: 1,
            newAccountId: '',
            invoice_filename: '',
            close_url: '',
            country_options: [],
            state_options: [],
            isAddLicenseSuccessModalVisible: false,
            isCCRequired: 1,
            paymentMethod: 'credit_card',
            isAddLicenseFailedModalVisible: false,
            isCreateInvoiceModalVisible: false,
            unit: 1,
            activeLicense: 0,
            popoverShow: false,
            licenseDetails: [],
            qty_options: [
              { value: '', text: 'Select' },
              { value: 1, text: 1 },
              { value: 2, text: 2 },
              { value: 3, text: 3 },
              { value: 4, text: 4 },
              { value: 5, text: 5 },
              { value: 6, text: 6 },
              { value: 7, text: 7 },
              { value: 8, text: 8 },
              { value: 9, text: 9 },
              { value: 10, text: 10 },
              { value: 11, text: 11 },
              { value: 12, text: 12 },
              { value: 13, text: 13 },
              { value: 14, text: 14 },
              { value: 15, text: 15 },
              { value: 16, text: 16 },
              { value: 17, text: 17 },
              { value: 18, text: 18 },
              { value: 19, text: 19 },
              { value: 20, text: 20 },
            ],
            seat_qty_options: [
              { value: '', text: '0' },
              { value: 1, text: 1 },
              { value: 2, text: 2 },
              { value: 3, text: 3 },
              { value: 4, text: 4 },
              { value: 5, text: 5 },
              { value: 6, text: 6 },
              { value: 7, text: 7 },
              { value: 8, text: 8 },
              { value: 9, text: 9 },
              { value: 10, text: 10 },
              { value: 11, text: 11 },
              { value: 12, text: 12 },
              { value: 13, text: 13 },
              { value: 14, text: 14 },
              { value: 15, text: 15 },
              { value: 16, text: 16 },
              { value: 17, text: 17 },
              { value: 18, text: 18 },
              { value: 19, text: 19 },
              { value: 20, text: 20 },
            ],
            licenseType: '',
            process_payment_disable: false,
            description: '',
            unitType: '',
            billing_name: '',
            billing_address: '',
            billing_address2: '',
            billing_city: '',
            billing_state: '',
            billing_country: '',
            billing_zip: '',
            billing_phone: '',
            payment_method: 'credit_card',
            invoice_filename: '',
            isNewPaymentMethodModalVisible: false,
            isPaymentListsModalVisible: false,
            cardName: '',
            cardNo: '',
            cardExpire: '',
            totalLicense: '',
            usedLicense: '',
            accountExpire: '',
            type: '',
            originalPrice: '',
            subscriptions_yearly: [],
            subscriptions_monthly: [],
            packageId: '',
            defaultpackageId: '',
            packageAmt: '',
            type: 'yearly',
            packagety: '',
            maxAdditionalSeatLimit: '',
            additionalSeatPrice: '',
            additionalSeatQty: '',
            totaladditionalSeatPrice: '',
            packagePrice: '',
            packageQtyDisplay: '',
            packageName: '',
            unlimited: false,
        }
    },
    components: {
      AddLicenseSuccessModal,
      AddLicenseFailedModal,
      CreateInvoiceConfirmModal,        
      NewPaymentMethod,
      PaymentLists,
    },
    methods: {       
        billingNameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },
        billingPhoneValid() {
            var billing_phone = this.billingPhone;
            this.billingPhone = billing_phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        getPostalCodeRegex() {
            return /^[0-9]{5}(?:-[0-9]{4})?$/;
        },
        getCountryLists() {
            axios.get('/get-country-lists', {

            })
            .then(response =>  {
                this.country_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getStateLists(CountryCode) {
            axios.get('/get-state-lists/' + CountryCode, {

            })
            .then(response =>  {
                this.state_options = response.data;
            })
            .catch(function(error) {

            });
        },
        getExpiryYears() {
            this.year_options = [
                { value: '', text: 'Year' },
            ];       
            var min = new Date().getFullYear()
            var max = min + 20;
            for (var i = min; i <= max; i++) {
                var yoptions = { value: i, text: i };
                this.year_options.push(yoptions);
            }
        },
        getAdditionalPriceforSubscription() {
          axios('/desktop/get-account-additional-seat-price',
          {
            method: 'GET',     
            params: {
              type: this.type,
              subscriptionId: this.subscriptionId,
              additionalSeatQty: this.additionalSeatQty,
            }

          })
          .then(resp => {  
            var additionalSeatPrice = resp.data.additionalSeatPrice;
            this.totaladditionalSeatPrice = additionalSeatPrice;
            var price = this.packagePrice;
            price = price.replace(",", "");
            this.total_amt = Math.round(parseFloat(price) + parseFloat(this.totaladditionalSeatPrice)).toFixed(2);
            this.subscriptionTotal = this.total_amt;
            this.subscriptionPrice = this.total_amt;
            this.unit = parseInt(this.packageQty + this.additionalSeatQty);
          })
          .catch(() => {
          });      

        },
        getAdditionalSeatMaxQuantity() {
          axios('/desktop/get-account-seat-max-seat/'+ this.packageId,
          {
            method: 'GET',
          })
          .then(resp => {     
            this.maxAdditionalSeatLimit = resp.data.maxAdditionalSeatLimit;
            
            if(this.maxAdditionalSeatLimit != '') {
              this.seat_qty_options = [];
              var qty =  { value: '', text: 0 };
              this.seat_qty_options.push(qty);
              for(var i=1; i <= this.maxAdditionalSeatLimit; i++) {
                  var qty = {value: i, text: i};
                  this.seat_qty_options.push(qty);
              }
            }

          })
          .catch(() => {
          });      

        },
        selectType(type) {
          this.type = type;
          this.packageId = this.defaultpackageId;
          if(this.type == 'yearly') {
            for(var i=0; i < this.subscriptions_yearly.length; i++) {
              this.subscriptions_yearly[i].isSelected = 0;
              this.subscriptions_yearly[i].checked = false;
              if(this.packageId == this.subscriptions_yearly[i].id) {
                this.subscriptions_yearly[i].isSelected = 1;
                this.subscriptions_yearly[i].checked = true;
                this.packageName = this.subscriptions_yearly[i].packageName;
                this.packageQty = this.subscriptions_yearly[i].qty;
                this.packagePrice = this.subscriptions_yearly[i].packagePrice;
                this.packageQtyDisplay = this.subscriptions_yearly[i].packageQty;
                this.unlimited = this.subscriptions_yearly[i].unlimited;
                var price = this.packagePrice + '.00';
                this.total_amt = price;
                this.subscriptionTotal = this.total_amt;
                this.subscriptionPrice = this.total_amt;
                this.totaladditionalSeatPrice = '';
                this.additionalSeatQty = '';
                this.unit = this.packageQty;
                this.getAdditionalSeatMaxQuantity();
              }
            }
          }
          else if(this.type == 'monthly') {
            for(var i=0; i < this.subscriptions_monthly.length; i++) {
              this.subscriptions_monthly[i].isSelected = 0;
              this.subscriptions_monthly[i].checked = false;
              if(this.packageId == this.subscriptions_monthly[i].id) {
                this.subscriptions_monthly[i].isSelected = 1;
                this.subscriptions_monthly[i].checked = true;
                this.packageName = this.subscriptions_monthly[i].packageName;
                this.packageQty = this.subscriptions_monthly[i].qty;
                this.packagePrice = this.subscriptions_monthly[i].packagePrice;
                this.packageQtyDisplay = this.subscriptions_monthly[i].packageQty;
                this.unlimited = this.subscriptions_yearly[i].unlimited;
                var price = this.packagePrice + '.00';
                this.total_amt = price;
                this.subscriptionTotal = this.total_amt;
                this.subscriptionPrice = this.total_amt;
                this.totaladditionalSeatPrice = '';
                this.additionalSeatQty = '';
                this.unit = this.packageQty;
                this.getAdditionalSeatMaxQuantity();
              }
            }
          }
        },
        clickPrimary: function(index, type) {
          if(type == 'yearly') {
            for(var i=0; i < this.subscriptions_yearly.length; i++) {
              this.subscriptions_yearly[i].isSelected = 0;
              this.subscriptions_yearly[i].checked = false;
            }
            this.subscriptions_yearly[index].isSelected = 1;
            this.subscriptions_yearly[index].checked = true;
            this.packageId = this.subscriptions_yearly[index].id;
            this.packageName = this.subscriptions_yearly[index].packageName;
            this.packageQty = this.subscriptions_yearly[index].qty;
            this.packagePrice = this.subscriptions_yearly[index].packagePrice;
            this.packageQtyDisplay = this.subscriptions_yearly[index].packageQty;
            this.unlimited = this.subscriptions_yearly[index].unlimited;
                var price = this.packagePrice + '.00';
                this.total_amt = price;
            this.subscriptionTotal = this.total_amt;
            this.subscriptionPrice = this.total_amt;
            this.totaladditionalSeatPrice = '';
            this.additionalSeatQty = '';
            this.unit = this.packageQty;
            this.getAdditionalSeatMaxQuantity();
          }
          else {
            for(var i=0; i < this.subscriptions_monthly.length; i++) {
              this.subscriptions_monthly[i].isSelected = 0;
              this.subscriptions_monthly[i].checked = false;
            }
            this.subscriptions_monthly[index].isSelected = 1;
            this.subscriptions_monthly[index].checked = true;
            this.packageId = this.subscriptions_monthly[index].id;
            this.packageName = this.subscriptions_monthly[index].packageName;
            this.packageQty = this.subscriptions_monthly[index].qty;
            this.packageQtyDisplay = this.subscriptions_monthly[index].packageQty;
            this.packagePrice = this.subscriptions_monthly[index].packagePrice;
            this.unlimited = this.subscriptions_yearly[index].unlimited;
                var price = this.packagePrice + '.00';
                this.total_amt = price;
            this.subscriptionTotal = this.total_amt;
            this.subscriptionPrice = this.total_amt;
            this.totaladditionalSeatPrice = '';
            this.additionalSeatQty = '';
            this.unit = this.packageQty;
            this.getAdditionalSeatMaxQuantity();
            }
        },
        getSubscriptionLists() {

          axios('/desktop/get-account-license-seat-subscription-lists/'+ this.$store.state.user_accountid,
          {
            method: 'GET'        
          })
          .then(resp => {     
            this.unlimited = resp.data.unlimited;
            this.unitType = resp.data.unitType;
            this.subscriptions_yearly = resp.data.subscriptions_yearly;
            this.subscriptions_monthly = resp.data.subscriptions_monthly;
            this.packageId = resp.data.packageId;  
            this.defaultpackageId = resp.data.packageId;
            this.total_amt = resp.data.total_amt;
            this.subscriptionId = resp.data.subscriptionId;
            this.subscriptions = resp.data.subscriptions;
            if(this.unitType == 'Seat') {
              this.unit = resp.data.unit;
              this.packageQty = resp.data.unit;
              this.subscriptionTotal = this.total_amt;
              this.subscriptionPrice = this.total_amt;
              this.packagePrice = this.total_amt;
              var price = this.packagePrice;
              this.total_amt = price;
              this.packageName = resp.data.packageName;
              this.maxAdditionalSeatLimit = resp.data.maxAdditionalSeatLimit;
              this.additionalSeatPrice = resp.data.additionalSeatPrice;
              this.packageQtyDisplay = resp.data.packageQtyDisplay;
              
              if(this.maxAdditionalSeatLimit != '') {
                this.seat_qty_options = [];
                var qty =  { value: '', text: 0 };
                this.seat_qty_options.push(qty);
                for(var i=1; i <= this.maxAdditionalSeatLimit; i++) {
                    var qty = {value: i, text: i};
                    this.seat_qty_options.push(qty);
                }
              }
            }
            else {
              this.unit = this.subscriptions[0].minQty;
              this.licenseType = this.subscriptions[0].licenseType;
              if((this.unit > 1)) {
                  this.qty_options = [];
                  var qty =  { value: '', text: 'Select' };
                  this.qty_options.push(qty);
                  for(var i=this.unit; i < 21; i++) {
                      var qty = {value: i, text: i};
                      this.qty_options.push(qty);
                  }
              }
              if(this.licenseType == 'Bundle License') {
                this.subscriptionPrice = this.subscriptions[0].price;
                this.subscriptionTotal = this.subscriptions[0].price;
              }
              else {
                this.subscriptionPrice = this.subscriptions[0].price;
                this.subscriptionTotal = this.subscriptions[0].price * this.unit;
              }
            }





          })
          .catch(() => {
          });      

        },



        nameRegex() {
            return /^[a-zA-Z-_ ']*$/;
        },

        openNewPaymentMethodModal() {
          this.isNewPaymentMethodModalVisible = true;
          this.$refs.NewPaymentMethodModal.loadInitialData();
        },
        openPaymentListsModal() {
          this.isPaymentListsModalVisible = true;
          this.$refs.PaymentListsModal.loadInitialData();
        },
        closePaymentMethod() {
          this.isNewPaymentMethodModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        closePaymentMethodLists() { 
          this.isPaymentListsModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        getPrimaryPaymentDetails() {

          axios('/desktop/get-payment-details/'+ this.$store.state.user_accountid,
          {
            method: 'GET'        
          })
          .then(resp => {        
            this.cardName = resp.data.cardName;
            if(this.cardName == '') {
              this.process_payment_disable = true;
            }
            else {
              this.process_payment_disable = false;
            }
            this.cardNo = resp.data.cardNo;
            this.cardExpire = resp.data.cardExpire;
            this.billing_name = resp.data.billing_name;
            this.billing_address = resp.data.billing_address;
            this.billing_address2 = resp.data.billing_address2;
            this.billing_city = resp.data.billing_city;
            this.billing_state = resp.data.billing_state;
            this.billing_country = resp.data.billing_country;
            this.billing_zip = resp.data.billing_zip;
            this.billing_phone = resp.data.billing_phone;
          })
          .catch(() => {
          });      

        },

        setSubscriptionTotal(item) {
          this.subscriptionId = item.id;
          this.subscriptionTotal = item.price;
        },
        onSubmit() {
          this.processPayment();
        },
        getPriceforSubscription: function() {
          axios('/getsubscriptionPrice',
            {
              method: 'GET',
              params: {
                subscriptionId: this.subscriptionId,
                qty: this.unit,
                accountId: this.$store.state.user_accountid,
              }
            }
          )
          .then(response => {
              this.subscriptions[0].price = response.data;
              if(this.licenseType == 'Bundle License') {
                this.subscriptionTotal = this.subscriptions[0].price;
              }
              else {
                this.subscriptionTotal = this.subscriptions[0].price * this.unit;
              }
              this.subscriptionPrice = response.data;
          })
          .catch(error => {

          });
        },
        processPayment() {
            this.process_payment_disable = true;
            this.loading = true;
            axios('/add-orders-new', 
            {
                method: 'POST',
                data: {
                        "subscription_id": this.subscriptionId,
                        "package_id": this.packageId,
                        "unitType": this.unitType,
                        "type": this.type,                
                        "subscription_price": this.subscriptionPrice,
                        "units": this.unit,
                        "description": this.description,
                        "subscription_total": this.subscriptionTotal,
                        "account_id": this.$store.state.user_accountid,
                        "billing_name": this.billingName,
                        "billing_address": this.billingAddress,
                        "billing_address2": this.billingAddress2,
                        "billing_city": this.billingCity,
                        "billing_state": this.billingState,
                        "billing_country": this.billingCountry,
                        "billing_zip": this.billingZip,
                        "billing_phone": this.billingPhone,
                        "payment_method": this.paymentMethod,
                        "name_oncard": this.nameOnCard,
                        "card_number": this.cardNumber,
                        "exp_month": this.expMonth,
                        "exp_year": this.expYear.toString().substr(-2),
                        "cvv_value": this.cvvValue,
                },
            })
            .then((response) => {
                this.process_payment_disable = false;
                this.loading = false;
                this.verrors.clear();
                this.invoice_filename = response.data.invoice_filename;
                if (response.data.msg != 'failed') {
                    this.isAddLicenseSuccessModalVisible = true;
                } else {
                    this.isAddLicenseFailedModalVisible = true;
                }
            })
            .catch(error => {
                this.process_payment_disable = false;
                console.log(error)
            });
        },
        getLicenseTermDetails() {
            axios.get('/desktop/get-license-term-details/' + this.subscriptionId)
            .then((resp) => {              
                this.licenseDetails = resp.data;                            
            })
            .catch(error => {

            });
        },
        loadInitialData() {
            this.type = 'yearly';
            this.verrors.clear();
            this.getSubscriptionLists();
            this.getExpiryYears();
            this.getCountryLists();
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0) {
                    return 'No Renew Subscription';
                }
            }
        },
        hide() { 
            this.$parent.closeAddSubscriptionListsModal();
        },
        close() {
            this.verrors.clear();
            if (this.close_url) {
                let routeData = this.$router.resolve({name: this.close_url});
                window.open(routeData.href, '_self');
            } else {
                let routeData = this.$router.resolve({name: 'managelicense'});              
                window.open(routeData.href, '_self');                
            }
        },
        choosePaymentMode(event) {
            if(event.target.value == 'credit_card') {
                this.isCCRequired = 1;
            }
            else {
                this.isCCRequired = 0;                
            }
        },
        onClose() {
          this.popoverShow = false
        },
    },
    created() {

    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.totalBtn, .totalBtn.btn-blue {
  color: #707070; 
  background-color: #FFF !important;
  border: 1px solid #707070 !important;
  border-radius: 10px;
  font-weight: 900;
  width: auto;
  padding: 8px;
}
.mx-input { height: 24px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  background-color: #efefef;
  min-height: 32px;
}
.ma-input-field:focus-visible {
  outline: none;
}
.form-label { font-weight: 900; } 
.row_data_border { padding: 5px 0; margin-bottom: 5px; margin-top: 10px; font-size: 14px;border-bottom: 2px solid rgba(0, 0, 0, 0.1); }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.custom-select { height: 34px; }
.license-term-content { font-size: 12px;}
.license-term-label { color: #00ACEE; font-weight: bold; font-size: 13px; padding-top: 10px;}
.help-txt {
    display: inline-block;
    height: 15px;
    width: 15px;
    line-height: 15px;
    -moz-border-radius: 8px;
    border-radius:8px;
    border: 1px solid #00ACEE;
    background-color: white;
    text-align: center;
    font-size: 0.75em;
    cursor: pointer;
}
.btn-secondary:hover { background-color: #FFF !important;}
input, select {
    line-height: 17px;
    border-radius: 10px;
    padding-left: 5px !important;
    border: 1px solid #707070;
}
.custom-select {
  font-size: 1rem !important;
  height: calc(1.5em + 0.75rem + 2px) !important;
}
.rounded {
    border-radius: 1rem !important;
}
.annual {
  font-size: 11px;
}
.black-border {
  border: 1px solid #002F42 !important;
}

</style>

<style>
.popover-body { padding-right: 50px !important;}
.popover-header div { text-align: center;}
button.close { font-size: 30px;margin-top: -7px;}
.popover .popover-header { font-size: 14px; font-weight: bold;}
.popover { width: 340px !important; max-width: 340px !important;}
.bs-popover-right > .arrow::before {
    border-right-color: rgba(0, 172, 238, 0.90) !important;
}

.card-header-tabs {
  width: 50%;
  float: right;
  margin: 0 !important;
  text-align: right;
  margin-bottom: 20px !important;
  box-shadow: 0 0px 5px rgba(0,0,0,.15)!important;
  border-radius: 1rem !important;
  padding: 3px 3px 4px 3px !important;
  margin-right: -20px !important;
}
.card-header-tabs li {
  width: 50%;
}
.nav-tabs .nav-link:hover {
  padding: 1px 8px !important;
  background-color: #FFF !important;
  border: 0 !important;
  font-weight: normal;
  color: #002F42 !important;
}
.nav-link, .nav-tabs .nav-item.show .nav-link, .nav-link, .nav-tabs .nav-item.show .nav-link:hover {
  padding: 1px 8px !important;
  background-color: #FFF !important;
  border: 0 !important;
  font-weight: normal;
}
.card-header li a, .card-header li a:hover {
    font-weight: normal !important;
    font-size: 13px !important;
    text-align: center;
}
.nav-tabs .nav-link.active {
  background-color: #082F42 !important;
  padding: 1px 8px !important;
  border-radius: 1rem !important;
  font-weight: normal;
  color: #FFF !important;
}
.card-header {
  border: 0 !important;
}
.tab-content {
  float: none;
  clear: both;
}

</style>


// WEBPACK FOOTER //
// src/components/manager/add_subscription.vue